<template>
  <Transition name="fade">
    <Dialog
      v-if="customTechPackModal"
      title="Custom Techpack"
      :showCloseButton="true"
      :showFooter="true"
      :showSaveButton="true"
      :showCancelButton="true"
      saveButtonText="Upload"
      cancelButtonText="Cancel"
      :sm="true"
      @closeEvent="closeEvent"
      @cancelEvent="closeEvent"
      @saveEvent="onSave"
    >
      <template #modal-content>
        <input
          type="file"
          ref="techpackFileRef"
          accept=".pdf"
          placeholder="Upload Custom Techpack"
        />
        <a
          class="download-techpack-button border-2 border-[#00B087] w-max p-2 hover:brightness-95 duration-200 flex gap-2 rounded-md text-[#00B087] mt-2"
          v-if="
            custom_techpack_modal_order &&
            custom_techpack_modal_order.techpack_data &&
            custom_techpack_modal_order.techpack_data.length > 0
          "
          :href="`${storage_url}/${custom_techpack_modal_order.techpack_data[custom_techpack_modal_order.techpack_data.length - 1].path}`"
          :key="`factory-await-${custom_techpack_modal_order.id}-custom-techpack`"
          target="_blank"
        >
          <ArrowDownTrayIcon class="size-6 text-[#00B087] mr-3" />
          Download Custom Techpack
        </a>
      </template>
    </Dialog>
  </Transition>
</template>
<script lang="ts" setup>
import Dialog from "@/components/Shared/Dialog.vue";
import { handleResponseException } from "@/interceptors/axiosRequestInterceptor";
import { Order } from "@/models";
import { useMainStore } from "@/store/index";
import { ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import { defineEmits, defineProps, onMounted, ref } from "vue";

const custom_techpack_modal_order = ref<Order | null>(null);
const customTechPackModal = ref<boolean | null>(false);
const props = defineProps<{
  order: Order;
}>();
const emits = defineEmits(["close"]);
const techpackFileRef = ref<HTMLInputElement | null>(null);
const store = useMainStore();
const storage_url = import.meta.env.VITE_APP_FILE_URL;

const closeEvent = () => {
  customTechPackModal.value = false;
  emits("close");
};

const onSave = async (): Promise<void> => {
  const customTechPackFileInputFiles: FileList | null | undefined =
    techpackFileRef.value?.files;
  if (
    customTechPackFileInputFiles &&
    customTechPackFileInputFiles.length > 0 &&
    custom_techpack_modal_order.value
  ) {
    try {
      await store.uploadCustomTechpack(
        customTechPackFileInputFiles,
        custom_techpack_modal_order.value,
      );
    } catch (err: any) {
      handleResponseException(err);
    }
  }
};
const showCustomTechPackModal = () => {
  custom_techpack_modal_order.value = props.order;
  customTechPackModal.value = true;
};

onMounted(() => {
  showCustomTechPackModal();
});
</script>
<style scoped lang="scss"></style>
